<div class="dragdrop-card-wrapper" [ngClass]="styleClass" [ngStyle]="style">
  <div cdkDropListGroup style="height: 100%;">
    <virtual-scroller #scroll [items]="cards" class="custom-scroller" [enableUnequalChildrenSizes]="true" style="height:100%;">
      <div *ngFor="let card of scroll.viewPortItems;let cardIndex=index;trackBy: cardTrackBy" class="card">
        <div class="head">
          <ng-container *ngTemplateOutlet="headTemplate||defaultHead;context:{$implicit:card}"></ng-container>
        </div>
        <div class="card-content" cdkDropList
          [cdkDropListData]="card" (cdkDropListDropped)="onDropCardItem($event)">
          <div class="card-item" *ngFor="let cardItem of card.children; let cardItemIndex=index;trackBy: cardItemTrackBy" cdkDrag
          [cdkDragData]="cardItem">
            <ng-container *ngTemplateOutlet="cardItemTemplate||defaultCardItem;context:{$implicit:cardItem}"></ng-container>
          </div>
        </div>
      </div>
    </virtual-scroller>
  </div>
</div>
<ng-template #defaultHead let-card>
  <div><span ellipsis style="display: inline-block; max-width: 80%;" >{{card.label}}</span>
    <span *ngFor="let labelIcon of card.labelIcons" class="ui-button ui-button-icon-only" style="vertical-align: top;"
    [ngStyle]="getStyle(labelIcon)"
    title="{{labelIcon.title}}" (click)="labelIcon.action($event)" >
      <i class="{{labelIcon.icon}}" aria-hidden="true"></i>
    </span>
  </div>
</ng-template>

<ng-template #defaultCardItem let-cardItem>
<div class="item-wrapper" style="position: relative;">
  <div class="toolbar-container" style="position: absolute;right:0;">
    <span *ngFor="let action of cardItem.actions" class="ui-button ui-button-icon-only" title="{{action.title}}"
    (click)="action.action($event)" [ngStyle]="getStyle(action)"
    >
      <i class="{{action.icon}}" aria-hidden="true"></i>
    </span>
  </div>
  <span class="item-label">{{cardItem.label}}</span>
</div>
</ng-template>
